import { render, staticRenderFns } from "./BmapRslpt.vue?vue&type=template&id=7bcf5821&"
import script from "./BmapRslpt.vue?vue&type=script&lang=js&"
export * from "./BmapRslpt.vue?vue&type=script&lang=js&"
import style0 from "./BmapRslpt.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports